import React, { useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import UserLayout from "../components/layouts/UserLayout";
import {Dashboard, Billing, Profile} from '../components/micromodulecomponent/common';
import Onboard from '../components/onboard/Onboard';
import { checkCookie, deleteCookie, getCookie } from "../helpers/Cookie";
import Utils from "../helpers/Utils";
import PaymentError from '../components/auth/PaymentError';
import {STRIPE_BILLING_AGENCY, TRUE_STRING} from '../helpers/CoreConstant';

const UserLayoutRouter = ({ component: Component, fullScreen, ...rest }) => {
    let url = ''
    const location = useLocation();
    let address = location.pathname
    if (address.includes("user/claim-contact")) {
        url = "?redirect_url=" + address
    }
    else if (address.includes("oauth2/authorize") && location.search !== undefined) {
        url = "?redirect_url=" + address + location.search
    }
    else {
        url = '';
    }
    const params = new URLSearchParams(location?.search);
    const from = params.get("from");

    const getUserSettingData = () => {

    };

    return (
        <Route {...rest} render={props => {
            if (checkCookie(process.env.REACT_APP_ACCESS_TOKEN)) {
                const agencyId = Utils.getAccountData('agencyId');
                const paymentFailed = Utils.getAccountData('payment_failed');
                
                if (STRIPE_BILLING_AGENCY.includes(agencyId) && paymentFailed) {
                  const logo = Utils.getAccountData('agencyLogo');
                  return <PaymentError agencyLogo={logo} />;
                }
                if (!(Utils.getAccountData('starterPack') || Utils.getAccountData('starterProPack') || Utils.getAccountData('standardPack'))) {

                    if (Utils.getAccountData('stripe_billing') && Utils.getAccountData('stripe_billing') === TRUE_STRING){
                        if (Component.name === Billing.name) {
                            return (
                                <UserLayout getUserSettingData={getUserSettingData}>
                                    <Component {...props} />
                                </UserLayout>
                            );
                        } else {
                            return <Redirect to="/user/billing/packages" />;
                        }
                    }else {
                        if (Component.name === Profile.name) {
                            return (
                                <UserLayout getUserSettingData={getUserSettingData}>
                                    <Component {...props} />
                                </UserLayout>
                            );
                        } else {
                            return <Redirect to="/user/packages" />;
                        }
                    }
                }

                if (!Utils.getAccountData('AuthUserAgencyAccountStatus')) {
                    if (Component.name === Dashboard.name) {
                        return (
                            <UserLayout getUserSettingData={getUserSettingData}>
                                <Component {...props} />
                            </UserLayout>
                        );
                    } else {
                        return <Redirect to="/" />;
                    }
                }

                if (Utils.getAccountData('userOnboard')) {

                    if (Utils.getAccountData('agencyBusinessType') === 'INSURANCE') {
                        if (from) {
                            if (from !== "onboard") {
                                return <Redirect to={`/onboarding`} />;
                            } else {
                                return (
                                    <UserLayout getUserSettingData={getUserSettingData}>
                                        <Component {...props} />
                                    </UserLayout>
                                );
                            }
                        } else {
                            return <Redirect to={`/onboarding`} />;
                        }
                    } else {
                        if (Component.name === Onboard.name) {
                            return (
                                <UserLayout getUserSettingData={getUserSettingData}>
                                    <Component {...props} />
                                </UserLayout>
                            );
                        }

                        const urlSearchParams = new URLSearchParams(window.location.search);
                        const { code } = Object.fromEntries(urlSearchParams.entries());

                        if (code) {
                            return <Redirect to={`/onboard?code=${code}`} />;
                        }

                        return <Redirect to="/onboard" />;
                    }

                } else {
                    if (Component.name === Onboard.name) {
                        return <Redirect to="/" />;
                    }

                    return (
                        <UserLayout getUserSettingData={getUserSettingData} fullScreen={fullScreen}>
                            <Component {...props} />
                        </UserLayout>
                    );
                }
            } else {
                if (url !== "") {

                    let to = "/user/login" + url
                    return <Redirect to={to} />;
                }
                return <Redirect to="/user/login" />;
            }
        }} />
    )
};

export default UserLayoutRouter;